/* Breakpoints */
export const FIGMA_MOBILE_SCREEN_WIDTH = 540;

export const FIGMA_COLUMN_FULL_WIDTH = 265;
export const FIGMA_COLUMN_GAP_FULL_WIDTH = 60;
export const FIGMA_TOP_PADDING_FULL_WIDTH = 133;

export const FIGMA_COLUMN_WIDTH_MOBILE =
  (152 / 375) * FIGMA_MOBILE_SCREEN_WIDTH; // according to figma
export const FIGMA_COLUMN_GAP_MOBILE = (31 / 375) * FIGMA_MOBILE_SCREEN_WIDTH; // according to figma
export const FIGMA_TOP_PADDING_MOBILE = 67;

export const FIGMA_SECTIONS_GAP = 100;
export const FIGMA_SECTIONS_GAP_MOBILE = 35;

export const PARAGRAPH_VERTICAL_PADDING = 5;
